import { render, staticRenderFns } from "./ProfessionalSkillsList.vue?vue&type=template&id=a984cabc&scoped=true&"
import script from "./ProfessionalSkillsList.vue?vue&type=script&lang=js&"
export * from "./ProfessionalSkillsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a984cabc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
